import React from 'react';
import HeroSection from '../components/HeroSection';
import { FeatureSections } from '../components/FeatureSections';
import { AppDownloadStrip } from '../components/AppDownloadStrip';

const Home = () => {
  return (
    <>
      <HeroSection />
      <FeatureSections />
      <AppDownloadStrip />
    </>
  );
};

export default Home;
